import dayjs from 'dayjs';
import * as Yup from 'yup';

const MaterialRequestFormSchema = Yup.object().shape({
  requiredOn: Yup.date()
    .required('Please Enter Required On date')
    .test(
      'requiredOn-rule-1',
      'Please enter valid Required On date - Required On date should be greater than 15 days from MR Request Date!',
      (value, context) => {
        const { reqDate } = context.parent;

        if (!reqDate) {
          return true;
        }
        const requestDate = dayjs(reqDate).startOf('day');
        const requiredOnDate = dayjs(value).startOf('day');

        const diff = requiredOnDate.diff(requestDate, 'days');

        return diff >= 15;
      }
    ),
  warrantyEndDate: Yup.date()
    .required('Please enter valid warranty date. It should greater than today!')
    .test(
      'should greater than today',
      'Please enter valid warranty date. It should greater than today!',
      (value) => {
        return dayjs(value).diff(dayjs().startOf('day'), 'days') > 0;
      }
    ),
});

export default MaterialRequestFormSchema;
